import { useQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { GuestsWorkspace } from '@/features/guests/pages/guests-workspace'
import { workspaceQueryOptions } from '@/lib/workspace'
export const Route = createFileRoute('/_auth/w/$workspaceSlug/guests')({
  validateSearch: z.object({
    q: z.string().max(300).optional().catch(''),
    view: z
      .string()
      .refine((v) => ['list', 'rsvp', 'settings'].includes(v))
      .optional()
      .catch('list'),
    guest: z
      .union([z.uuid(), z.literal('new')])
      .optional()
      .catch(undefined),
    page: z.number().int().min(1).optional().catch(1),
    category: z.string().optional().catch('all'),
    status: z.string().optional().catch('all'),
    day: z.string().optional().catch('all'),
    diet: z.string().optional().catch('all'),
    children: z.boolean().optional().catch(false),
  }),
  component: Screen,
})
function Screen() {
  const { workspaceSlug } = Route.useParams()
  const workspace = useQuery(workspaceQueryOptions(workspaceSlug))
  return (
    <GuestsWorkspace
      key={workspaceSlug}
      slug={workspaceSlug}
      canWrite={workspace.data?.role === 'owner' || workspace.data?.role === 'editor'}
    />
  )
}
